import React, { useEffect, useRef, useState } from 'react'

import Button from 'components/button'
import useDoHit from 'api/mutations/punch'
import useDoHitStream from 'api/mutations/simulate-hit-stream'
import { useTabletsBagsQuery } from 'api/queries/tablets-bags'
import { getStoredApiKey } from 'lib/auth-token'
import './hit-me-btn.scss'

const filterDataByKey = (data: any) => {
  return data?.apiKey?.find((item: any) => item.key === getStoredApiKey())
}

// These buttons are used for testing purposes only:
// - "Hit me!" sends a direct simulated hit.
// - "Packet stream" replays sensor packets through the stream detection pipeline.
const HitMeBtn = () => {
  const doHit = useDoHit()
  const doHitStream = useDoHitStream()
  const { data } = useTabletsBagsQuery()
  const [isPacketStreaming, setIsPacketStreaming] = useState(false)
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null)
  const streamInFlightRef = useRef(false)

  const isProduction = process.env.REACT_APP_API_URL === 'api.nextroundboxing.com' // TODO handle this with explicit env vars

  const runPacketStream = async () => {
    if (streamInFlightRef.current) {
      return
    }

    const currentAlgorithm = filterDataByKey(data)?.tablet?.[0]?.bag?.[0]?.hitDetectionAlgorithm
    console.log('[Packet stream] hitDetectionAlgorithm:', currentAlgorithm || 'unknown')

    streamInFlightRef.current = true
    try {
      await doHitStream()
    } finally {
      streamInFlightRef.current = false
    }
  }

  const togglePacketStream = () => {
    if (isPacketStreaming) {
      setIsPacketStreaming(false)
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
        intervalRef.current = null
      }
      return
    }

    setIsPacketStreaming(true)
    runPacketStream()
    intervalRef.current = setInterval(runPacketStream, 2500)
  }

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current)
      }
    }
  }, [])

  return isProduction ? (
    <></>
  ) : (
    <div className="hitMeBtn">
      <Button customClickEvent={doHit}>
        <h3>Hit me!</h3>
      </Button>
      <Button customClickEvent={togglePacketStream}>
        <h3>{isPacketStreaming ? 'Stop packet stream' : 'Packet stream'}</h3>
      </Button>
    </div>
  )
}

export default HitMeBtn
